export const initialProviderProfile = {
  deaNumber: 'BL123456',
  email: 'sjohnson@elcamino.com',
  firstName: 'Sarah',
  individualNpi: '1073841112',
  lastName: 'Johnson',
  licenseNumber: '1073841557',
  phoneNumber: '(916) 555-1234',
  specialization: 'Internal Medicine',
  specialtyTaxonomy: '207R00000X',
  userName: 'sjohnson'
};